import { $applyNodeReplacement, setNodeIndentFromDOM } from "lexical";
import { CodeBlockNode } from "./CodeBlockNode.js";
const $createCodeBlockNode = ()=>$applyNodeReplacement(new CodeBlockNode());
const $isCodeBlockNode = (node)=>node instanceof CodeBlockNode;
const $convertCodeBlockElement = (element)=>{
    const node = $createCodeBlockNode();
    if (element.style) {
        node.setFormat(element.style.textAlign);
        setNodeIndentFromDOM(element, node);
    }
    return {
        node
    };
};
export { $convertCodeBlockElement, $createCodeBlockNode, $isCodeBlockNode };
